import React from "react";
import { Paper } from "@material-ui/core";

const NotFound = () => {
  return (
    <Paper elevation={3} style={{ height: "100%" }}>
      <div className="col-md-4 pt-5 mx-auto">
        <h3>Page Not Found</h3>
        <span>Ever felt like you're in a wrong place?</span>
      </div>
    </Paper>
  );
};

export default NotFound;
